const container = new Map<Function, any>();

function Service<T extends { new (...args: any[]): {} }>(constructor: T) {
  if (!container.has(constructor)) {
    container.set(constructor, new constructor());
  }
}

function Inject<T>(serviceClass: new () => T) {
  return function (target: any, key: string) {
    const serviceInstance = container.get(serviceClass);

    if (serviceInstance) {
      // ? Getter To avoid Vue intstance initialization
      Object.defineProperty(target, key, {
        get() {
          return serviceInstance;
        },
        enumerable: true,
        configurable: true,
      });
    }
  };
}

export {
  Service,
  Inject
};